import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import GoldStar from 'components/ChatSettingsV2/GoldStar';
import ReactSelect from 'components/ReactSelect/ReactSelect';
import Switch from 'components/Switch/Switch';
import { translationLanguages } from 'enum/chatSettings';
import { generateID } from 'utils/helpers';

import translateIcon from '../../../images/translator.png';

import styles from './ChatTranslationPicker.css';


const IDs = {
  prefix: 'HyT4Fg6Y',
  element: 'chatTranslationPicker',
  languages: 'languages',
  translator: 'translator',
  showOriginalLang: 'showOriginalLang',
};

const makeId = generateID(IDs.prefix, IDs.element);

const ChatTranslationPicker = ({
  descriptionClassName,
  handleLanguageSelectChange,
  handleShowOriginalLanguage,
  handleTranslationActiveToggle,
  languageCode,
  selectClassName,
  showOriginalLanguage,
  switchWrapperClass,
  textClassName,
  translationSettingsAreActive,
  withGoldRestrictions,
}) => (
  <Fragment>
    <div className={styles.translatorTitle}>
      <div className={textClassName}>
        <img alt="" src={translateIcon} />
        <span>
          {translate('v2profile.chat.translator')}
        </span>
      </div>
      <Switch
        checked={translationSettingsAreActive}
        color="default"
        id={makeId(IDs.translator)}
        wrapperClassName={switchWrapperClass}
        onChange={handleTranslationActiveToggle}
      />
    </div>
    {withGoldRestrictions && <GoldStar />}
    <div className={descriptionClassName}>
      {translate('v2profile.translate.chat.messages')}
    </div>
    <ReactSelect
      className={selectClassName}
      clearable={false}
      disabled={!translationSettingsAreActive}
      id={makeId(IDs.languages)}
      menuContainerStyle={{ top: 'auto', bottom: '100%' }}
      options={translationLanguages}
      searchable={false}
      value={languageCode}
      onChange={handleLanguageSelectChange}
    />
    {translationSettingsAreActive && (
      <div className={styles.translatorTitle}>
        <p className={textClassName}>
          {translate('v2profile.translate.show.original.language')}
        </p>
        <Switch
          checked={showOriginalLanguage}
          color="default"
          id={makeId(IDs.showOriginalLang)}
          wrapperClassName={switchWrapperClass}
          onChange={handleShowOriginalLanguage}
        />
      </div>
    )}
  </Fragment>
);

ChatTranslationPicker.defaultProps = {
  descriptionClassName: undefined,
  handleTranslationActiveToggle: () => undefined,
  handleLanguageSelectChange: () => undefined,
  handleShowOriginalLanguage: () => undefined,
  languageCode: undefined,
  showOriginalLanguage: false,
  switchWrapperClass: undefined,
  selectClassName: undefined,
  translationSettingsAreActive: false,
  textClassName: undefined,
  withGoldRestrictions: false,
};

ChatTranslationPicker.propTypes = {
  descriptionClassName: PropTypes.string,
  handleLanguageSelectChange: PropTypes.func,
  handleShowOriginalLanguage: PropTypes.func,
  handleTranslationActiveToggle: PropTypes.func,
  languageCode: PropTypes.string,
  selectClassName: PropTypes.string,
  showOriginalLanguage: PropTypes.bool,
  switchWrapperClass: PropTypes.string,
  textClassName: PropTypes.string,
  translationSettingsAreActive: PropTypes.bool,
  withGoldRestrictions: PropTypes.bool,
};

export default ChatTranslationPicker;
